export default "__VITE_ASSET__BHPqNFoD__"